export interface SocialMediaOption {
    id: number;
    label: string;
    icon: string;
    domains: string[]; // empty = generic (matches any URL)
}

export const socialMediaOptions: SocialMediaOption[] = [
    { id: 1,  label: 'facebook',   icon: 'FaFacebookF',      domains: ['facebook.com'] },
    { id: 2,  label: 'x',          icon: 'FaXTwitter',        domains: ['x.com', 'twitter.com'] },
    { id: 3,  label: 'instagram',  icon: 'FaInstagram',       domains: ['instagram.com'] },
    { id: 4,  label: 'twitch',     icon: 'FaTwitch',          domains: ['twitch.tv'] },
    { id: 5,  label: 'linkedin',   icon: 'FaLinkedinIn',      domains: ['linkedin.com'] },
    { id: 6,  label: 'github',     icon: 'FaGithub',          domains: ['github.com'] },
    { id: 7,  label: 'youtube',    icon: 'FaYoutube',         domains: ['youtube.com', 'youtu.be'] },
    { id: 8,  label: 'dev.to',     icon: 'FaDev',             domains: ['dev.to'] },
    { id: 9,  label: 'discord',    icon: 'FaDiscord',         domains: ['discord.com', 'discord.gg'] },
    { id: 10, label: 'hackerrank', icon: 'FaHackerrank',      domains: ['hackerrank.com'] },
    { id: 11, label: 'dribbble',   icon: 'FaDribbble',        domains: ['dribbble.com'] },
    { id: 12, label: 'tiktok',     icon: 'FaTiktok',          domains: ['tiktok.com'] },
    { id: 13, label: 'link',       icon: 'FaLink',            domains: [] },
    { id: 14, label: 'medium',     icon: 'FaMedium',          domains: ['medium.com'] },
    { id: 15, label: 'skype',      icon: 'FaSkype',           domains: ['skype.com'] },
    { id: 16, label: 'spotify',    icon: 'FaSpotify',         domains: ['spotify.com'] },
    { id: 17, label: 'pinterest',  icon: 'FaPinterest',       domains: ['pinterest.com'] },
    { id: 18, label: 'snapchat',   icon: 'FaSnapchat',        domains: ['snapchat.com'] },
    { id: 19, label: 'reddit',     icon: 'FaRedditAlien',     domains: ['reddit.com'] },
    { id: 20, label: 'telegram',   icon: 'FaTelegramPlane',   domains: ['telegram.org', 't.me'] },
    { id: 21, label: 'threads',    icon: 'FaThreads',         domains: ['threads.net'] },
    { id: 22, label: 'tumblr',     icon: 'FaTumblr',          domains: ['tumblr.com'] },
    { id: 23, label: 'whatsapp',   icon: 'FaWhatsapp',        domains: ['wa.me', 'whatsapp.com'] },
];
